// Wraps fetch so network-level failures don't throw an unhandled "Load failed" /
// "Failed to fetch" TypeError up to Sentry. These happen when the request never
// completes (user offline, on a flaky mobile connection, navigated away mid-request,
// or the server was briefly unreachable) and are not actionable.
//
// Returns the Response on success, or null when the request never completed. Callers
// should treat null the same as a non-ok response, e.g. `if (!response?.ok) { ... }`.
export async function safeFetch(url, options) {
    try {
        return await fetch(url, options);
    } catch (e) {
        console.warn("Network request failed", url, e);
        return null;
    }
}
